(() => {
  if (window.whosifyGalleryV7) {
    window.whosifyGalleryV7.init(document);
    return;
  }
  const instances = new Map();
  function create(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-w-gallery-track]');
    const slides = Array.from(root.querySelectorAll('[data-w-gallery-slide]'));
    if (!track || slides.length < 2) return;
    const controls = root.querySelector('[data-w-gallery-controls]');
    const dots = Array.from(root.querySelectorAll('[data-w-gallery-dot]'));
    const toggle = root.querySelector('[data-w-gallery-toggle]');
    const status = root.querySelector('[data-w-gallery-status]');
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoEnabled = root.dataset.wGalleryAutoplay === 'true';
    const interval = Math.max(4000, Number(root.dataset.wGalleryInterval) || 6000);
    const abort = new AbortController();
    const listen = (node, type, handler, options = {}) => node.addEventListener(type, handler, { ...options, signal: abort.signal });
    let index = 0;
    let userPaused = false;
    let hovered = false;
    let focused = false;
    let visible = !('IntersectionObserver' in window);
    let timer = null;
    let scrollTimer = null;
    let manualMove = false;
    let lastWidth = track.clientWidth;
    function update() {
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === index ? 'false' : 'true'));
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (toggle) {
        toggle.hidden = !autoEnabled || media.matches;
        toggle.setAttribute('aria-pressed', String(userPaused));
        toggle.querySelector('[data-w-gallery-pause]').hidden = userPaused;
        toggle.querySelector('[data-w-gallery-play]').hidden = !userPaused;
      }
    }
    function schedule() {
      window.clearTimeout(timer);
      timer = null;
      if (!autoEnabled || userPaused || hovered || focused || !visible || media.matches || document.hidden) return;
      timer = window.setTimeout(() => go(index + 1, false), interval);
    }
    function go(next, manual = true, instant = false) {
      index = (next + slides.length) % slides.length;
      manualMove = manual;
      if (manual) userPaused = true;
      const left = track.scrollLeft + slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollTo({ left, behavior: instant || media.matches ? 'auto' : 'smooth' });
      update();
      if (manual && status) status.textContent = `Image ${index + 1} of ${slides.length}／第 ${index + 1} 張，共 ${slides.length} 張`;
      schedule();
    }
    function settled() {
      const left = track.getBoundingClientRect().left;
      let nearest = 0;
      let distance = Infinity;
      slides.forEach((slide, i) => {
        const nextDistance = Math.abs(slide.getBoundingClientRect().left - left);
        if (nextDistance < distance) { nearest = i; distance = nextDistance; }
      });
      index = nearest;
      update();
      if (manualMove && status) status.textContent = `Image ${index + 1} of ${slides.length}／第 ${index + 1} 張，共 ${slides.length} 張`;
      manualMove = false;
      schedule();
    }
    listen(root.querySelector('[data-w-gallery-prev]'), 'click', () => go(index - 1));
    listen(root.querySelector('[data-w-gallery-next]'), 'click', () => go(index + 1));
    dots.forEach((dot, i) => listen(dot, 'click', () => go(i)));
    if (toggle) listen(toggle, 'click', () => { userPaused = !userPaused; update(); schedule(); });
    listen(track, 'keydown', event => {
      const target = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: slides.length - 1 }[event.key];
      if (target === undefined) return;
      event.preventDefault();
      go(target);
    });
    listen(root, 'mouseenter', () => { hovered = true; schedule(); });
    listen(root, 'mouseleave', () => { hovered = false; schedule(); });
    listen(root, 'focusin', () => { focused = true; schedule(); });
    listen(root, 'focusout', event => { focused = root.contains(event.relatedTarget); schedule(); });
    listen(track, 'pointerdown', () => { userPaused = true; manualMove = true; update(); schedule(); });
    listen(track, 'touchstart', () => { userPaused = true; manualMove = true; update(); schedule(); }, { passive: true });
    listen(track, 'scroll', () => { window.clearTimeout(scrollTimer); scrollTimer = window.setTimeout(settled, 140); }, { passive: true });
    listen(document, 'visibilitychange', schedule);
    listen(media, 'change', () => { update(); schedule(); });
    const intersection = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      schedule();
    }, { threshold: 0.2 }) : null;
    intersection?.observe(root);
    const resize = 'ResizeObserver' in window ? new ResizeObserver(() => {
      if (track.clientWidth === lastWidth) return;
      lastWidth = track.clientWidth;
      go(index, false, true);
    }) : null;
    resize?.observe(track);
    root.setAttribute('data-w-gallery-ready', '');
    if (controls) controls.hidden = false;
    update();
    schedule();
    instances.set(root, {
      go,
      slides,
      destroy() {
        window.clearTimeout(timer);
        window.clearTimeout(scrollTimer);
        abort.abort();
        intersection?.disconnect();
        resize?.disconnect();
        slides.forEach(slide => slide.removeAttribute('aria-hidden'));
        root.removeAttribute('data-w-gallery-ready');
        if (controls) controls.hidden = true;
        instances.delete(root);
      }
    });
  }
  function init(scope) {
    if (scope.matches?.('[data-w-gallery]')) create(scope);
    scope.querySelectorAll?.('[data-w-gallery]').forEach(create);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => { if (event.target.contains(root)) instance.destroy(); });
  });
  document.addEventListener('shopify:block:select', event => {
    instances.forEach(instance => {
      const selected = instance.slides.findIndex(slide => slide.dataset.wGalleryBlock === event.detail?.blockId || slide.contains(event.target));
      if (selected >= 0) instance.go(selected);
    });
  });
  window.whosifyGalleryV7 = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
